import { render, staticRenderFns } from "./pointItem.vue?vue&type=template&id=6838a9e8&scoped=true"
import script from "./pointItem.vue?vue&type=script&lang=js"
export * from "./pointItem.vue?vue&type=script&lang=js"
import style0 from "./pointItem.vue?vue&type=style&index=0&id=6838a9e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6838a9e8",
  null
  
)

export default component.exports